// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 600px;
    padding: 15px;
    font-family: Arial, sans-serif;
    background: var(--clr-primary-9);
}

.terms-text {
    /* font-size: 15px; */
    color: #444;
    text-align: left;
    line-height: 1.5;
}

.terms-link {
    color: #007bff;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    transition: color 0.3s ease;
}

.terms-link:hover {
    color: #0056b3;
    text-decoration: underline;
}

.terms-checkbox-container {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-top: 5px;
}

.terms-checkbox-container input[type="checkbox"] {
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #007bff;
    border-radius: 3px;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
}

.terms-checkbox-container input[type="checkbox"]:checked {
    background-color: #007bff;
    border-color: #007bff;
}

.terms-checkbox-container input[type="checkbox"]::before {
    content: "✔";
    font-size: 12px;
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: none;
}

.terms-checkbox-container input[type="checkbox"]:checked::before {
    display: block;
}

.terms-checkbox-container label {
    /* font-size: 14px; */
    color: #333;
    cursor: pointer;
}

.Toastify__toast-container {
    font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PdfViewer/TermsAndConditions.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".terms-container {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    max-width: 600px;\n    padding: 15px;\n    font-family: Arial, sans-serif;\n    background: var(--clr-primary-9);\n}\n\n.terms-text {\n    /* font-size: 15px; */\n    color: #444;\n    text-align: left;\n    line-height: 1.5;\n}\n\n.terms-link {\n    color: #007bff;\n    font-weight: bold;\n    cursor: pointer;\n    text-decoration: none;\n    transition: color 0.3s ease;\n}\n\n.terms-link:hover {\n    color: #0056b3;\n    text-decoration: underline;\n}\n\n.terms-checkbox-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding-top: 5px;\n}\n\n.terms-checkbox-container input[type=\"checkbox\"] {\n    appearance: none;\n    width: 18px;\n    height: 18px;\n    border: 2px solid #007bff;\n    border-radius: 3px;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.2s ease;\n}\n\n.terms-checkbox-container input[type=\"checkbox\"]:checked {\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.terms-checkbox-container input[type=\"checkbox\"]::before {\n    content: \"✔\";\n    font-size: 12px;\n    color: white;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: none;\n}\n\n.terms-checkbox-container input[type=\"checkbox\"]:checked::before {\n    display: block;\n}\n\n.terms-checkbox-container label {\n    /* font-size: 14px; */\n    color: #333;\n    cursor: pointer;\n}\n\n.Toastify__toast-container {\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
